import ax from '../axios'
import {API_URL} from "../index";

const STORY_QUESTION_GROUP_URL = API_URL.QUESTION_MODULE+"/question-group";

const getStoryQuestionGroups = (query: string) => {
    return ax.get(`${STORY_QUESTION_GROUP_URL}?${query}`)
}
const getStoryQuestionGroup = (query: any) => {
    return ax.get(`${STORY_QUESTION_GROUP_URL}/${query.storyId}/${query.languageCode}`)
}

export {
    getStoryQuestionGroups,
    getStoryQuestionGroup
}
